import styled from 'styled-components';

export const Container = styled.div`
  padding: 0.5rem 0;
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

export const ModalHeader = styled.div`
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
`;

export const ModalBody = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
`;

export const ControladoLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: normal;

  span {
    font-size: 0.875rem;
    color: #495057;
  }

  input:disabled + span {
    color: #adb5bd;
  }
`;
